import { render, staticRenderFns } from "./SpeakerIcon.vue?vue&type=template&id=a745a554&"
import script from "./SpeakerIcon.vue?vue&type=script&lang=js&"
export * from "./SpeakerIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports